module.exports = {
    subscribe(cb) {
        window.addEventListener('resize', cb);
    },
    unsubscribe(cb) {
        window.removeEventListener('resize', cb);
    }
}
